import React, { useState, useEffect, useRef } from 'react';
import Amplify from 'aws-amplify';
import { Row, Col } from 'antd';

import { getCustomerProducts } from '@app/services/home.service';
import triangle03 from '@app/assets/svg/03.svg';
import triangle06 from '@app/assets/svg/06.svg';
import triangle01 from '@app/assets/svg/01.svg';
import triangle02 from '@app/assets/svg/02.svg';
import ServiceCard from '@app/modules/components/ServiceCard/ServiceCard';
import ServiceCardSkeleton from '@app/modules/components/ServiceCardSkeleton/ServiceCardSkeleton';
import { appsConfig } from '@app/modules/config/appsConfigs';
import './home.css';
import { usePrevious } from '@app/hooks/usePrevius';

const Home = (props) => {
  const [products, setProducts] = useState(null);
  const previusCustomer = usePrevious(props.customerData);

  useEffect(() => {
    if (JSON.stringify(previusCustomer) !== JSON.stringify(props.customerData)) {
      setProducts(null);
      if (props.customerData?.accountCustomerCode) {
        getCustomerProducts({
          customer_code: props.customerData?.accountCustomerCode,
        }).then((response) => {
          setProducts(response.data.getCustomerProducts.data.products);
        });
      }
    }
  }, [props.customerData]);

  function orderProductsByAvailability(products = []) {
    const enabledProducts = products.filter(
      (prod) => prod.enabled && prod.status === 'Enabled'
    );
    const disabledProducts = products.filter(
      (prod) => !(prod.enabled && prod.status === 'Enabled')
    );
    return [...enabledProducts, ...disabledProducts];
  }

  return (
    <div>
      <span style={{ position: 'absolute', bottom: '180px', left: '0%' }}>
        <img src={triangle03}></img>
      </span>
      <span style={{ position: 'absolute', bottom: '170px', left: '48px' }}>
        <img src={triangle06}></img>
      </span>
      <span
        style={{ position: 'absolute', top: '65px', right: '0%', zIndex: -1 }}
      >
        <img src={triangle01}></img>
      </span>
      <span
        style={{ position: 'absolute', bottom: '0', right: '0', zIndex: -1 }}
      >
        <img src={triangle02}></img>
      </span>
      <div
        style={{
          marginLeft: '10%',
          marginTop: '5%',
        }}
      >
        <div>
          <label className='dm-home-title-hello'>
            {Amplify.I18n.get('Hello')}
          </label>
        </div>
        <div>
          <label className='dm-home-title-name'>
            {
              JSON.parse(localStorage.getItem('user-profile')).attributes
                .given_name
            }
          </label>
        </div>
        <br />
        <div>
          <p className='dm-home-title-hello'>
            {Amplify.I18n.get('What would you like to start with today?')}
          </p>
        </div>
        <div>
          <Row gutter={[24, 32]} style={{ margin: 0 }}>
            {products
              ? orderProductsByAvailability(products)
                .filter((p) => appsConfig[p.code]?.type === 'app')
                .map((product) => {
                  return (
                    <Col>
                      <ServiceCard
                        disabled={
                          !(product.enabled && product.status === 'Enabled')
                        }
                        url={appsConfig[product.code].url}
                        serviceIcon={appsConfig[product.code].icon}
                        serviceName={product.name}
                        serviceDescription={
                          product.description[props.language]
                        }
                        size={appsConfig[product.code].size}
                      />
                    </Col>
                  );
                })
              : [1, 2, 3].map(() => (
                <Col>
                  <ServiceCardSkeleton size='big' />
                </Col>
              ))}
          </Row>
        </div>
        <br />
        <br />
        <div style={{ fontSize: 16 }}>
          <p className='dm-home-title-hello' style={{ fontSize: 16 }}>
            {Amplify.I18n.get('Other tools')}
          </p>
        </div>
        <div>
          <Row gutter={[16, 24]} style={{ margin: 0 }}>
            {products
              ? orderProductsByAvailability(products)
                .filter((p) => appsConfig[p.code]?.type === 'tool')
                .map((product) => {
                  return (
                    <Col>
                      <ServiceCard
                        disabled={
                          !(product.enabled && product.status === 'Enabled')
                        }
                        url={appsConfig[product.code].url}
                        serviceIcon={appsConfig[product.code].icon}
                        serviceName={product.name}
                        serviceDescription={
                          product.description[props.language]
                        }
                        size={appsConfig[product.code].size}
                      />
                    </Col>
                  );
                })
              : [1, 2, 3, 4, 5, 6, 7].map(() => (
                <Col>
                  <ServiceCardSkeleton size='small' />
                </Col>
              ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Home;
